import { Subscription, merge } from 'rxjs';
import { Injectable } from '@angular/core';
import { Status } from '@df/core/status';

@Injectable({
    providedIn: 'root'
})
export class OperationalSafeguardsService {
    private statuses: Status[] = [];

    private subscriptions = new Subscription();

    private handlerActive = false;

    private beforeUnloadHandler = (event: BeforeUnloadEvent) => {
        if (this.isBusy) {
            event.preventDefault();
        }
    };

    add(status: Status): void {
        if (typeof this.getIndex(status) === 'undefined') {
            this.statuses.push(status);
            this.onStatusesChange();
        }
    }

    remove(status: Status): void {
        const index = this.getIndex(status);
        if (typeof index === 'number') {
            this.statuses.splice(index, 1);
            this.onStatusesChange();
        }
    }

    private onStatusesChange(): void {
        this.subscriptions.unsubscribe();
        if (this.statuses.length) {
            this.subscriptions = new Subscription();
            this.subscriptions.add(
                merge(...this.statuses.map(i => i.subject)).subscribe(() => {
                    this.onStatusChange();
                })
            );
        }
        this.onStatusChange();
    }

    private onStatusChange(): void {
        if (typeof window !== 'undefined') {
            if (this.isBusy) {
                if (!this.handlerActive) {
                    window.addEventListener('beforeunload', this.beforeUnloadHandler);
                    this.handlerActive = true;
                }
            } else if (this.handlerActive) {
                window.removeEventListener('beforeunload', this.beforeUnloadHandler);
                this.handlerActive = false;
            }
        }
    }

    private get isBusy(): boolean {
        return !!this.statuses.find(i => i.busy);
    }

    private getIndex(status: Status): number | undefined {
        const index = this.statuses.indexOf(status);

        if (index > -1) {
            return index;
        }

        return undefined;
    }
}
